import { Note } from "../note/Note"

export class DashboardOrderDetails {
  buildTypeName: string
  cartridgeName: string
  customerName: string
  daysInShop: number
  daysInStep: number
  daysWaitingToBeStarted: number
  isStarted: boolean
  notes: Note[]
  onHold: boolean
  orderId: number
  scheduledDate?: string

  showNotes: boolean

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(json: any) {
    this.buildTypeName = json.buildTypeName
    this.cartridgeName = json.cartridgeName
    this.customerName = json.customerName
    this.daysInShop = json.daysInShop
    this.daysInStep = json.daysInStep
    this.daysWaitingToBeStarted = json.daysWaitingToBeStarted
    this.isStarted = json.isStarted
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.notes = json.notes ? json.notes.map((n: any) => new Note(n.id, n.content, n.customerVisible, n.lastModifiedByUser, n.lastModifiedDate)) : []
    this.onHold = json.onHold
    this.orderId = json.orderId
    this.scheduledDate = json.scheduledDate

    this.showNotes = false
  }
}
